import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { useUtils } from '../utils/utils';
import { useLocation } from "react-router-dom";

// Helper functions
function toDateObj(ts) {
  if (ts.seconds) {
    return new Date(ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6);
  }
  return new Date(ts._seconds * 1000 + (ts._nanoseconds || 0) / 1e6);
}

function formatTime(d, timeZone) {
  // hh:mm (24 hour)
  return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone });
}

function formatHHMM(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${(h + '').padStart(2, '0')}:${(m + '').padStart(2, '0')}`;
}

const RideInfoLine = ({ rideInfo }) => {
  const {formatTextDate} = useUtils();
  const location = useLocation();

  // Use rideInfo.id directly as ride date (already in ddMMMyyyy format)
  const rideDate = rideInfo.id;

  const highestTime = rideInfo.highest ? toDateObj(rideInfo.highest.time) : 'N/A';
  const lowestTime = rideInfo.lowest ? toDateObj(rideInfo.lowest.time) : 'N/A';
  const startTime = toDateObj(rideInfo.startTime);
  const endTime = toDateObj(rideInfo.endTime);

  return (
    <Row>
      {
        location.pathname.includes('tours') &&
        <>
          <Col xs="auto">
            <strong>{formatTextDate(rideDate)}</strong>
          </Col>
          <Col xs="auto">
            <span><Badge bg="secondary">{rideInfo.title}</Badge></span>
          </Col>
        </>
      }
      <Col xs="auto">
        <Badge bg="secondary">
          <span>({rideInfo.timeZone}) {formatTime(startTime, rideInfo.timeZone)} to {formatTime(endTime, rideInfo.timeZone)} = {formatHHMM(rideInfo.onRoadSeconds)} </span>
        </Badge>
      </Col>
      <Col xs="auto">
        <Badge bg="secondary"><strong>{rideInfo.distance} Km</strong></Badge>
      </Col>
      {
        rideInfo.locations[0].altitude &&
        <Col xs="auto">
          <Badge bg="secondary"> 
            Altitudes - Start: <strong>{rideInfo.locations[0].altitude.toFixed(1)} m</strong>, 
              End: <strong>{rideInfo.locations[rideInfo.locations.length - 1].altitude.toFixed(1)} m</strong>, 
              Gain: <strong>{rideInfo.netAltitudeGain.toFixed(1)} m</strong>
          </Badge>       
        </Col>
      }
      { rideInfo.highest && 
        <Col xs="auto">
          <Badge bg="secondary"> 
              High: <strong>{rideInfo.highest.altitude.toFixed(1)} m at {formatTime(highestTime, rideInfo.timeZone)}</strong>
          </Badge>
        </Col>
      }
      { rideInfo.lowest &&
        <Col xs="auto">
          <Badge bg="secondary"> 
            <strong>
              Low: <span>{rideInfo.lowest.altitude.toFixed(1)} m</span> at <span>{formatTime(lowestTime, rideInfo.timeZone)}</span>
            </strong>
          </Badge>
        </Col>
      }
    </Row>
  );
};

export default RideInfoLine;
